import {Component} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {DateFieldService} from '../../services/date-field/date-field.service';
import {MdDatepickerInputEvent} from '@angular/material';


@Component({
  selector: 'app-date',
  templateUrl: './date-field.component.html',
  styleUrls: ['./date-field.component.css']
})
export class DateFieldComponent extends FieldComponentAbstract {

  constructor(private dateService: DateFieldService) { super() }

  handleDateChange(event: any) {
    const value = (<MdDatepickerInputEvent<string>>event).target.value;
    this.fieldValue.date_value = value ? this.dateService.getServerDateString(new Date(value)) : null;
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/date-field/date-field.component.ts